import { useTranslation } from 'react-i18next';
import type { TranslationKey } from '@/i18n/translation-key.tsx';

export const useTranslations = () => {
  const { t, i18n } = useTranslation();
  return (key: TranslationKey | string, params?: Record<string, string | number>, fallback?: string) => {
    if (i18n.exists(key, params)) {
      const translated = t(key, params);
      if (translated && translated !== key && !translated.includes('returned an object instead of string')) {
        return translated;
      }
    }
    return fallback ?? key;
  };
};
